import { WREX_VIEW_CLASSNAME } from '@lumapps/wrex/constants';

/** Check if the text/plain data is a lumapps html content view */
export const doesDataContainsLumappsHtmlText = (data: DataTransfer): boolean => {
    const parser = new DOMParser();
    const rawText = data.getData('text/plain');

    if (rawText) {
        const htmlDocument = parser.parseFromString(rawText, 'text/html');
        const wrexViewElement = htmlDocument.body.querySelector(`.${WREX_VIEW_CLASSNAME}`);

        return !!wrexViewElement;
    }

    return false;
};
